import ViewChannelSidebar from './ViewChannelSidebar'

export default ViewChannelSidebar
